<template>
  <div class="container_box">
    <!--头部筛选区域-->
    <div class="filter_box">
      <Form ref="pageParams" :model="pageParams" :label-width="labelWidth" @submit.native.prevent>
        <Row type="flex" :gutter="gutterItem">
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1002399')" prop="ymsWarehouseId">
              <Select v-model="pageParams.ymsWarehouseId" filterable>
                <Option v-for="item in warehouseList" :key="item.ymsWarehouseId" :value="item.ymsWarehouseId">{{ item.name }}</Option>
              </Select>
            </Form-item>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <FormItem :label="$t('key1004752')" prop="pickingGoodsNo">
              <Input v-model.trim="pageParams.code" clearable></Input>
            </FormItem>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <FormItem :label="$t('key1001995')" prop="pickingNo">
              <Input v-model.trim="pageParams.ymsPackageCode" clearable></Input>
            </FormItem>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <FormItem :label="$t('key1000207')">
              <local-tabButton :tabButtonList="pickListTypeList" @selectStatus="typeChange"></local-tabButton>
            </FormItem>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1001180')">
              <Date-picker
                style="width:100%"
                type="datetimerange"
                @on-clear="resetDate"
                @on-change="getDateValue"
                :clearable="true"
                :options="dateOptions"
                format="yyyy-MM-dd HH:mm:ss"
                placement="bottom-end"
                :placeholder="$t('key1000360')"
                :value="timeValue">
              </Date-picker>
            </Form-item>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <FormItem :label="$t('key1004753')">
              <local-tabButton :tabButtonList="printStatusList" @selectStatus="printStatusChange"></local-tabButton>
            </FormItem>
          </Col>
          <Col :xxl="twoItemCol" :xl="twoItemCol" :lg="oneItemCol" :md="oneItemCol">
            <FormItem :label="$t('key1004704')">
              <local-tabButton :tabButtonList="pickListStatusList" @selectStatus="pickListStatusBtn"></local-tabButton>
            </FormItem>
          </Col>
          <Col style="min-width: 200px;">
            <Button @click="reset" icon="md-refresh" class="mr10">{{ $t('key1000109') }}</Button>
            <Button type="primary" @click="search" icon="md-search">{{ $t('key1000361') }}</Button>
          </Col>
        </Row>
      </Form>
    </div>
    <div class="shipping_method">
      <!--邮件方式-->
      <div class="left_box">
        <div class="option_btn" v-if="!upOrDown" @click="switchBtn">
          <Icon size="20" type="ios-arrow-forward"/>
        </div>
        <shippingMethod
          :upOrDown="upOrDown"
          @switchOption="switchOption"
          @selectCheckBox="selectCheckBox"
          :showCheckbox="true"
          :treeData="treeData">
        </shippingMethod>
      </div>
      <div class="right_box" :style="upOrDown ? 'width: 77%' : 'width: 100%'">
        <!--功能按钮操作区域-->
        <div class="operation_box" :style="upOrDown ? '' : 'padding-left: 35px;'">
          <div class="mr15 sort_options_box">
            <span>{{ $t('key1004046') }}</span>
            <Button-group>
              <Button
                :type="item.checked ? 'primary' : 'default'"
                v-for="item in sortData"
                @click="clickSortButton(item)"
                :key="item.value">{{ item.label }}
                <Icon type="md-arrow-up" v-if="item.checked && !item.toogle"></Icon>
                <Icon type="md-arrow-down" v-if="item.checked && item.toogle"></Icon>
              </Button>
            </Button-group>
          </div>
          <Dropdown transfer @on-click="batchOption">
            <Button icon="ios-copy-outline">
              <span>{{ $t('key1004754') }}</span>
              <Icon type="md-arrow-dropdown"></Icon>
            </Button>
            <template #list>
              <DropdownMenu>
                <DropdownItem name="0" v-if="getPermission('ymsPickingOrder_pickingOrderGoodsDetailList')">{{ $t('key1004755') }}</DropdownItem>
                <DropdownItem name="1" v-if="getPermission('ymsPickingOrder_batchMarkPicking')">{{ $t('key1004756') }}</DropdownItem>
              </DropdownMenu>
            </template>
          </Dropdown>
        </div>
        <!--列表区域-->
        <div class="table_box">
          <Table
            highlight-row
            border
            ref="selection"
            :columns="tableColumns"
            :loading="tableLoading"
            :data="tableData"
            max-height="550"
            @on-selection-change="tableChange">
          </Table>
          <Page
            :transfer="true"
            v-if="!tableLoading"
            :total="total"
            :current="pageParams.pageNum"
            :page-size="pageParams.pageSize"
            show-total
            show-sizer
            show-elevator
            placement="top"
            @on-change="changePage"
            @on-page-size-change="changePageSize"
            :page-size-opts="pageArray">
          </Page>
        </div>
      </div>
    </div>
    <!--订单取消提示-->
    <orderCancelPromptModal ref="orderCancelPrompt" @updateData="search"></orderCancelPromptModal>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';
import shippingMethod from "@/components/common/shippingMethod";
import orderCancelPromptModal from "@/components/common/orderCancelPromptModal";
import {getUserNameByUserId, ymsVerifyPicking, getEnableWarehouseData, getWarehouseName, getAllUsersInfo,
  getWarehouseId, getDataSetBatchList, getEnumList, getEnumName} from "@/utils/common";

export default {
  name: "pickList",
  mixins: [Mixin],
  data() {
    var v = this;
    let end = new Date();
    let start = new Date();
    start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
    return {
      pageParamsStatus: false,
      warehouseList: [],
      treeData: [],
      payTimeArr: [start, end],
      clearAble: true,
      upOrDown: true,
      checkAllShip: false,
      indeterminateAll: false,
      workShow: 'list',
      cacheClickVal: 'CT',
      orderSeq: 'DESC',
      total: 0,
      pickingGoodsNo: '', // 拣货单编号
      wareId: getWarehouseId(),
      pageParams: {
        code: "", // 拣货单号
        orderBy: "CT",
        orderSeq: "DESC",
        packageGoodsType: 0,
        printedType: 0,
        startCreatedTime: null,
        endCreatedTime: null,
        status: 1,
        ymsPackageCode: "",
        ymsWarehouseId: 'null',
        pickingExtendList: null,
        pageNum: 1,
        pageSize: 10
      },
      wareList: [],
      printStatusList: [
        {selected: true, value: 0, title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000110')},
        {selected: false, value: 1, title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004740')},
        {selected: false, value: 2, title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004741')}
      ],
      sortData: [
        {label: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004742'), value: 'CT', checked: true, toogle: true},
        {label: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004743'), value: 'WS', checked: false, toogle: true}
      ],
      tableColumns: [],
      tableData: [],
      tableSltData: [],
      pickingStatus: '',
      batchPrintData: [],
      pickingGoodsNos: [],
      timeValue: [],
      userInfoList: {},
      enumData: [],
      currentIndex: 0,
      currentPickIndex: 0
    };
  },
  computed: {
    // 拣货单类型
    pickListTypeList() {
      const ENUM_KEY = 'YmsPickingOrderPackageGoodsTypeCoreEnum';
      let list = getEnumList(this.enumData, ENUM_KEY, 'number');
      list.unshift({
        selected: true,
        value: 0,
        title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000110')
      });
      list.forEach((item,index) => {
        item.selected = index === this.currentIndex;
      });
      return list;
    },
    // 拣货单状态
    pickListStatusList() {
      const ENUM_KEY = 'YmsPickingOrderStatusCoreEnum';
      let list = getEnumList(this.enumData, ENUM_KEY, 'number');
      list.unshift({
        selected: true,
        value: null,
        title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000110')
      });
      list.forEach((item,index) => {
        item.selected = index === this.currentPickIndex;
      });
      return list;
    }
  },
  created() {
    this.initFun();
  },
  methods: {
    // 初始化接口数据
    initFun() {
      let v = this;
      v.setDefaultTimerParams('three_months');
      (async () => {
        let enumKeyList = [
          'YmsPickingOrderPackageGoodsTypeCoreEnum',
          'YmsPickingOrderSourceCoreEnum',
          'YmsPickingOrderStatusCoreEnum'
        ];
        v.enumData = await getDataSetBatchList(enumKeyList);
        await getEnableWarehouseData(1).then((data) => {
          v.warehouseList = data || [];
        });
        await getAllUsersInfo().then((data) => {
          v.userInfoList = data;
        });
        await v.getAllShipMethod();
        if (v.warehouseList && v.warehouseList.length) {
          v.pageParams.ymsWarehouseId = v.warehouseList[0].ymsWarehouseId;
          v.getList();
        }
      })();
    },
    // 重置时间
    resetDate() {
      let v = this;
      v.pageParams.startCreatedTime = null;
      v.pageParams.endCreatedTime = null;
    },
    // 获取日期返回值
    getDateValue(value) {
      let v = this;
      if (value.length === 0) {
        v.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000356'));
        v.resetDate();
      } else {
        if (!value[0]) {
          v.pageParams.startCreatedTime = null;
          v.pageParams.endCreatedTime = null;
        } else {
          let timeList = v.defaultTimePeriod(value);
          v.timeValue = v.defaultTimePeriod(value, false);
          v.pageParams.startCreatedTime = v.$uDate.getUniversalTime(new Date(timeList[0]).getTime(), 'fulltime');
          v.pageParams.endCreatedTime = v.$uDate.getUniversalTime(new Date(timeList[1]).getTime(), 'fulltime');
        }
      }
    },
    // 选取拣货单状态
    pickListStatusBtn(index, value) {
      this.pageParams.status = value;
      this.currentPickIndex = index;
    },
    // 选取拣货单类型
    typeChange(index, value) {
      let v = this;
      v.pageParams.packageGoodsType = value;
      v.currentIndex = index;
    },
    // 选取打印状态
    printStatusChange(index, value) {
      let v = this;
      v.pageParams.printedType = value;
      v.printStatusList.forEach((n, i) => {
        n.selected = i === index;
      });
    },
    // 排序按钮
    clickSortButton(data) {
      if (data.value === this.pageParams.orderBy) {
        data.toogle = !data.toogle;
      }
      this.pageParams.orderBy = data.value;
      if (data.toogle) {
        this.pageParams.orderSeq = 'DESC'; // 降
      } else {
        this.pageParams.orderSeq = 'ASC';
      }
      this.sortData.forEach(function (n) {
        n.checked = data.value === n.value;
      });
      this.getList();
    },
    // 查询按钮
    search() {
      if (this.pageParams.pickingGoodsStatus === '7') { // 已包装
        if (this.pageParams.startCreatedTime === null || this.pageParams.endCreatedTime === null) {
          this.$Message.warning({
            content: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004744'),
            duration: 4
          });
          return false;
        }
      }
      this.pageParams.pickingExtendList = null;
      this.pageParams.pageNum = 1;
      this.getAllShipMethod();
      this.getList();
    },
    // 处理参数
    handleParameter() {
      let query = JSON.parse(JSON.stringify(this.pageParams));
      query.ymsWarehouseId = this.pageParams.ymsWarehouseId === 'null' ? null : this.pageParams.ymsWarehouseId;
      return query;
    },
    // 列表查询的方法
    getList() {
      this.optionBtnWidth = [];
      this.tableData = [];
      this.total = 0;
      if (this.getPermission('ymsPickingOrder_query')) {
        let obj = this.handleParameter();
        this.axios.post(api.post_ymsPickingOrder, obj).then(res => {
          this.handleColumns(obj.status);
          if (res.data.code === 0) {
            let data = res.data.datas;
            if (data) {
              this.tableData = data.list || [];
              this.total = data.total;
              this.updateTableDom('selection');
            }
          } else {
            this.tableLoading = false;
          }
        });
      } else {
        this.gotoError();
      }
    },
    // 标记为已拣货 (标记之前要校验出库单中是否存在有已取消的订单，如果存在取消的订单则弹出取消订单提示窗)
    markHasPicked(url, params) {
      ymsVerifyPicking(api.put_ymsPickingOrder_checkPickingOrder, params).then((data) => {
        if (data.length > 0) {
          this.$refs['orderCancelPrompt'].basicData = data;
          this.$refs['orderCancelPrompt'].orderCancelPromptModal = true;
        } else {
          this.axios.put(url, params).then(res => {
            if (res.data.code === 0) {
              this.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004745'));
              this.getList();
            }
          });
        }
      });
    },
    // 勾选中列表数据
    tableChange(data) {
      this.tableSltData = data;
    },
    // 批量操作
    batchOption(val) {
      let v = this;
      if (this.tableSltData.length === 0) {
        this.$Message.warning({
          content: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004746'),
          duration: 3
        });
        return;
      }
      if (val === '1') {
        let arr = this.tableSltData.map(val => {
          return val.ymsPickingOrderId;
        });
        this.markHasPicked(api.put_ymsPickingOrder_batchMarkPicking, arr);
      } else {
        // 批量打印拣货单
        let val = [];
        if (v.tableSltData.length > 0) {
          v.tableSltData.forEach((n, i) => {
            val.push(n.ymsPickingOrderId);
          });
        }
        v.pickingGoodsNos = val;
        let goto = this.$router.resolve({
          path: '/printPickListBatch',
          query: {
            data: v.pickingGoodsNos.join(','),
            type: 'pickList',
            where: 'sell'
          }
        });
        window.open(goto.href, '_blank');
      }
    },
    // 展开与收起邮寄方式
    switchBtn() {
      this.upOrDown = !this.upOrDown;
    },
    switchOption(val) {
      this.upOrDown = val;
    },
    // 重置按钮
    reset() {
      this.pageParams.code = '';
      this.pageParams.ymsPackageCode = '';
      this.typeChange(0, 0);
      this.printStatusChange(0, null);
      this.pickListStatusBtn(1, 1);
      this.pageParams.pageNum = 1;
      this.$refs['pageParams'].resetFields();
      this.pageParams.pickingExtendList = null;
      this.timeValue = [];
      this.resetDate();
      this.setDefaultTimerParams('three_months');
      this.search();
      this.getAllShipMethod();
    },
    // 处理列表字段
    handleColumns(status) {
      let v = this;
      v.optionBtnWidth = [];
      v.tableColumns = [];
      let columns = [
        {
          type: 'selection',
          width: 60,
          key: 'selection',
          fixed: 'left',
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004694'),
          key: 'code',
          align: 'center',
          fixed: 'left',
          minWidth: 250,
          render: (h, params) => {
            let objLabel = {
              TEMU_S: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004409'),
              TEMU_P: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004410'),
            };
            let orderType = params.row.orderType;
            let labelName = objLabel[orderType];
            return h('div', {
              class: 'flex align-items-center'
            }, [
              h('Alink', {
                props: {
                  linkName: params.row.code
                },
                on: {
                  AlinkBtn: () => {
                    const {href} = v.$router.resolve({
                      path: '/wms/pickListDetails',
                      query: {
                        ymsPickingOrderId: params.row.ymsPickingOrderId,
                        where: 'ymsPick'
                      }
                    });
                    window.open(href, '_blank');
                  }
                }
              }),
              labelName ? h('span', {
                style: {
                  marginLeft: '6px',
                  border: '1px solid #2D8CF0',
                  padding: '1px 4px',
                  borderRadius: '4px',
                  color: '#2D8CF0'
                }
              }, labelName) : ''
            ]);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004688'),
          key: 'packageGoodsType',
          minWidth: 130,
          align: 'center',
          render(h, params) {
            let packageGoodsType = params.row.packageGoodsType;
            let text = getEnumName(v.enumData, 'YmsPickingOrderPackageGoodsTypeCoreEnum', packageGoodsType);
            return h('span', text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004747'),
          key: 'status',
          align: 'center',
          minWidth: 130,
          render(h, params) {
            let text = '';
            let status = params.row.status;
            v.pickListStatusList.map((item) => {
              if (item.value === status) {
                text = item.title;
              }
            });
            return h('div', text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004748'),
          key: 'printStatus',
          align: 'center',
          minWidth: 130,
          render: (h, params) => {
            return h('div', (params.row.printedBy && params.row.printedTime) ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004741') : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004740'));
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002390'),
          key: 'warehouseName',
          minWidth: 130,
          align: 'center',
          render(h, params) {
            return h('span', getWarehouseName(v.warehouseList, params.row.ymsWarehouseId));
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004749'),
          key: 'skuQuantity',
          align: 'center',
          minWidth: 130,
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004062'),
          key: 'skuNumber',
          align: 'center',
          sortable: true,
          minWidth: 130,
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004733'),
          key: 'pickedTime',
          width: 170,
          align: 'center',
          sortable: true,
          render: (h, params) => {
            return h('span', v.$uDate.getDataToLocalTime(params.row.pickedTime, 'fulltime'));
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004692'),
          key: 'source',
          minWidth: 130,
          align: 'center',
          render(h, params) {
            let source = Number(params.row.source);
            let text = getEnumName(v.enumData, 'YmsPickingOrderSourceCoreEnum', source, 'number');
            return h('span', text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002158'),
          key: 'createdBy',
          minWidth: 130,
          align: 'center',
          render(h, params) {
            return h('span', getUserNameByUserId(params.row.createdBy, v.userInfoList));
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002159'),
          key: 'createdTime',
          width: 170,
          align: 'center',
          sortable: true,
          render: (h, params) => {
            return h('span', v.$uDate.getDataToLocalTime(params.row.createdTime, 'fulltime'));
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000319'),
          key: 'options',
          fixed: 'right',
          width: 160,
          align: 'center',
          render: (h, params) => {
            return h('optsButtonList', {
              props: {
                operationList: [
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001963'),
                    show: params.row.status === 1 && v.getPermission('ymsPickingOrder_markPicking'),
                    clickFn: () => {
                      v.markHasPicked(api.put_ymsPickingOrder_markPicking, [params.row.ymsPickingOrderId]);
                    }
                  }
                ]
              },
              on: {
                setWidth(value) {
                  if (value) {
                    v.optionBtnWidth.push(value);
                    params.column.width = Math.max(...v.optionBtnWidth);
                    v.$forceUpdate();
                  }
                }
              }
            });
          }
        }
      ];
      let hideFieldKeyList = []; // ['packageGoodsType', 'skuQuantity', 'skuNumber']; (拣货单类型、SKU数、货品数)
      if (status === 1) {
        let list = columns.filter((item) => {
          if (!hideFieldKeyList.includes(item.key)) {
            return item;
          }
        });
        v.$nextTick(() => {
          v.tableColumns = list;
        });
      } else {
        v.$nextTick(() => {
          v.tableColumns = columns;
        });
      }
    },
    // 选中的邮寄方式
    selectCheckBox(arr) {
      let paramsArr = [];
      if (arr.length > 0) {
        arr.map((item) => {
          if (item.shippingMethodId) {
            paramsArr.push({
              logisticsMailCode: item.shippingMethodId
            });
          }
        });
      }
      let list = this.uniqueFunc(paramsArr, 'logisticsMailCode');
      this.pageParams.pickingExtendList = list || null;
      this.getList();
    },
    // 获取邮寄方式的数据
    getAllShipMethod() {
      let v = this;
      let {pageSize, pageNum, ...obj} = v.handleParameter();
      v.treeData = [];
      v.axios.post(api.post_ymsPickingOrder_querySalesPickingCarriers, obj).then(res => {
        if (res.data.code === 0) {
          let data = res.data.datas || [];
          if (data.length > 0) {
            data.forEach(val => {
              val.title = val.carrierName === null ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004750') : val.carrierName;
              val.expand = true;
              val.pickingNumber = val.count;
              if (val.shippingMethods) {
                val.shippingMethods.forEach(val2 => {
                  val2.title = val2.shippingMethodName === null ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004751') : val2.shippingMethodName;
                  val2.expand = true;
                  val2.pickingNumber = val2.count;
                });
              }
              val.children = val.shippingMethods || [];
            });
            if (data.length !== 0) {
              v.treeData = [
                {
                  title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000110'),
                  expand: true,
                  pickingNumber: 0,
                  children: []
                }
              ];
              v.treeData[0].pickingNumber = data.reduce((a, b) => {
                return a + b.count;
              }, 0);
              v.treeData[0].children = data;
            }
          }
        }
      });
    },
  },
  watch: {
    pageParamsStatus(value) {
      let v = this;
      if (value) {
        v.getList();
        v.pageParamsStatus = false;
      }
    }
  },
  components: {
    orderCancelPromptModal,
    shippingMethod
  }
};
</script>

<style lang="less" scoped>
.shipping_method {
  width: 100%;
  position: relative;
  display: flex;
  justify-content: space-around;

  .left_box {
    position: relative;

    .option_btn {
      position: absolute;
      top: 0;
      left: 0;
      height: 56px;
      background-color: #2b85e4;
      color: #fff;
      width: 25px;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
    }
  }

  .right_box {
    min-width: 830px;
  }
}
</style>
